import { Breadcrumbs } from '@wix/design-system';
import { ReactElement } from 'react';
import { useEntityPageHeader } from '../../state/EntityPage';
import { MoreActionsElement } from '../MoreActions';

export interface EntityPageHeaderProps {
  /**
   * <MoreActions />
   */
  moreActions?: MoreActionsElement;
  /**
   * Page breadcrumbs
   */
  breadcrumbs?: ReactElement<Breadcrumbs>;
  /**
   * Page title text
   */
  title: { text: string };
  /**
   * Page subtitle text
   */
  subtitle?: { text: string };
}

export type EntityPageHeaderElement = ReactElement<
  EntityPageHeaderProps,
  typeof EntityPageHeader
>;

export function EntityPageHeader(_props: EntityPageHeaderProps) {
  return null;
}

EntityPageHeader.useEntityPageHeader = useEntityPageHeader;
EntityPageHeader.displayName = 'EntityPageHeader';
